import type {AddSupplierNoteFormPayload} from "./add-supplier-note.schema";

import {addSupplierNote} from "@project/sdk/engineering";
import {mutationOptions} from "@tanstack/react-query";

import {supplierKeys, supplierMutationKeys} from "../../../../../supplier-keys";

export function addSupplierNoteMutationOptions(supplierId: string) {
  return mutationOptions({
    mutationKey: supplierMutationKeys.addSupplierNote,
    mutationFn: (payload: AddSupplierNoteFormPayload) => addSupplierNote(supplierId, payload),
    onSuccess: async (_noteId, _payload, _context, {client}) => {
      await Promise.all([
        client.invalidateQueries({queryKey: supplierKeys.detail(supplierId)}),
        client.invalidateQueries({queryKey: supplierKeys.lists()}),
      ]);
    },
  });
}
